import { useQuery } from '@tanstack/react-query'
import { remoteDownloadsQuery, remoteQuery } from '../api/opteemum'
import { remoteDownloadUrl } from '../api/remoteConnect'
import { RemoteConnectHost } from '../remote_connect/RemoteConnectLaunch'
import { remoteColumns } from './columns'
import { RemoteConnectTabs } from './RemoteConnectTabs'
import { OpteemumTablePage } from './TablePage'

/**
 * Opteemum::remote_connect - `#overviewRemoteConnect`.
 *
 * Citirea listei e identica. Peste ea sta din nou butonul de descarcare a
 * clientului: pe macheta veche era primul lucru de pe ecran (`.dataTableA`
 * prepend), fiindca omul care deschide pagina asta pentru prima oara nu are
 * inca unealta cu care sa se conecteze. In v4 lipsea cu totul, si pe ecran
 * ramanea o lista de masini fara nicio cale de a ajunge la ele.
 *
 * Ce se poate descarca hotaraste serverul (`RemoteDownloads`): kiturile
 * RustDesk pleaca de pe serverul de download, cu adrese absolute care merg de
 * oriunde. Clientul ScreenConnect se ia de la API
 * (`GET /api/v2/remote-connect/download/client`, `Remote_connect::downloadClient`),
 * din `download/` de la radacina portalului.
 *
 * Butonul verde de pe fiecare rand (`#remoteConnectModal` in HTML-ul de la
 * server) e prins de `RemoteConnectHost` si deschide direct pagina de lansare
 * RustDesk - ScreenConnect e scos din uz (12 septembrie 2026).
 *
 * Randul desfacut e cel din `remote_connect/actionsTabs.php` - Details /
 * Session journal / Remote Permissions (`Remote_connect::getRemoteTabs`), nu
 * fisa intreaga a aparatului, cum era pana acum.
 */

function DownloadKits() {
  const kits = useQuery(remoteDownloadsQuery)
  const links = kits.data?.links ?? []

  if (!kits.data?.allowed) {
    return null
  }

  /* ScreenConnect: butonul din macheta veche (`remote_connect/downloadClient`),
     servit acum de API, nu de o ruta CodeIgniter. */
  if (kits.data.tool !== 'rustdesk') {
    return (
      <a className="btn btn-primary tk-header-extra" href={remoteDownloadUrl('client')}>
        <i className="fa fa-download"></i> Download Client
      </a>
    )
  }

  if (links.length === 0) {
    return null
  }

  return (
    <div className="btn-group tk-header-extra">
      <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i className="fa fa-download"></i> Download RustDesk Client <span className="caret"></span>
      </button>
      <ul className="dropdown-menu arrow pull-right">
        {links.map((kit) => (
          <li key={kit.url}>
            <a href={kit.url} title={kit.hint}>
              <i className={kit.icon}></i> {kit.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export function RemotePage() {
  return (
    <RemoteConnectHost>
      <OpteemumTablePage
        id="overviewRemoteConnect"
        columns={remoteColumns()}
        queryOf={remoteQuery}
        details={(row) => <RemoteConnectTabs id={Number(row.ID ?? row.deviceId)} />}
        headerButtons={
          <>
            {/* CEC 65: jurnalul sesiunilor si inregistrarile (drept separat, pe server). */}
            <a className="btn btn-default tk-header-extra rcs-log-link" href="/app/opteemum/remote_sessions">
              <i className="fas fa-history"></i> Session log
            </a>
            <DownloadKits />
          </>
        }
        rowKey={(r) => Number(r.ID ?? r.deviceId)}
      />
    </RemoteConnectHost>
  )
}
